import request from '../utils/request'
export function search(name){
    return request({
        url:'/h5/goods/search',
        method:'get',
        params:{
            name
        }
    })
}
